import type { ReactNode } from 'react';
import {
  BellAlertIcon,
  CheckIcon,
  SparklesIcon,
  StarIcon,
} from '@heroicons/react/24/outline';

export const proBenefits: Array<{ icon: ReactNode; label: string }> = [
  {
    icon: <CheckIcon className="h-4 w-4 text-white" />,
    label: 'Everything in Free Account',
  },
  {
    icon: <StarIcon className="h-4 w-4 text-white" />,
    label: 'Saved search preferences (procuring orgs, industries, keywords)',
  },
  {
    icon: <BellAlertIcon className="h-4 w-4 text-white" />,
    label: 'Email notifications for new opportunities matching your preferences',
  },
  {
    icon: <SparklesIcon className="h-4 w-4 text-white" />,
    label: 'Personalised My Feed dashboard showing opportunities relevant to your preferences',
  },
];
